import React from "react";
import { useHistory } from "react-router";
import arrow from "../images/arrowLeft.png";
import play from "../images/play.png";

function BioDetails() {
  const history = useHistory();
  return (
    <div className="BioDetails">
      <div className="BioDetails__Back" onClick={() => {history.push("/")}}>
        <img
          className="BioDetails__Back--Img"
          src={arrow}
          alt=""
        />
        <div className="BioDetails__Back--Para">BACK</div>
      </div>
      <div className="BioDetails__Content">
        <div className="BioDetails__Content--Head">Teachers' Biographies</div>
        <div className="BioDetails__Content--Para1">
          Teachers' Biographies is a collection of beautiful stories of teachers across the country who work day in and out, relentlessly for their students.
        </div>
        <div className="BioDetails__Content--Para1">
        The series is a celebration of how these teachers have lived their lives in pursuit of fulfilling the dreams of their students. As part of this series, we at Classplus documented their struggles, inspirations, vision, and reasons for becoming a teacher.
        </div>
        <div className="BioDetails__Content--Para1">
        Traveling through cities, we met 100s of teachers and heard their stories. Watch out for this space for more stories of teachers of India and their mission to educate India.
        </div>
        <div className="BioDetails__Content--Para1">
        Embark on this journey with Classplus and watch the first episode of this series now!
        </div>
        <button className="BioDetails__Content--Btn" onClick={()=> history.push('/39')}>
          <img className="BioDetails__Content--Btn__Img" src={play} alt="" />
          <div className="BioDetails__Content--Btn__Para">Watch Now</div>
        </button>
      </div>
    </div>
  );
}

export default BioDetails